/* eslint-disable */
/**
 * AUTO-GENERATED FILE — DO NOT EDIT.
 *
 * Generated by: scripts/generate-embedded-inkjs-exports.mjs
 * Source: inkjs@2.3.2 (inkjs/full ESM entry)
 * Generated at: 2026-03-01T21:38:24.729Z
 */

export const EMBEDDED_INKJS_23_VERSION = "2.3.2" as const;

export const EMBEDDED_INKJS_23_NAMED_EXPORTS = [
  "Compiler",
  "CompilerOptions",
  "InkList",
  "InkParser",
  "JsonFileHandler",
  "StatementLevel",
  "Story"
] as const;
